import { render, staticRenderFns } from "./designedProductsList.vue?vue&type=template&id=4d81783f&scoped=true"
import script from "./designedProductsList.vue?vue&type=script&lang=js"
export * from "./designedProductsList.vue?vue&type=script&lang=js"
import style0 from "./designedProductsList.vue?vue&type=style&index=0&id=4d81783f&prod&lang=less"
import style1 from "./designedProductsList.vue?vue&type=style&index=1&id=4d81783f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d81783f",
  null
  
)

export default component.exports